import { render, staticRenderFns } from "./amendments.vue?vue&type=template&id=62ad9501"
import script from "./amendments.vue?vue&type=script&lang=js"
export * from "./amendments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports